
import { parseCalendarDate } from '@/lib/calendarDate';

// Photos is jsonb at rest and some import batches wrote [{ url }] objects
// where the runtime convention is a plain URL string array; a raw object in
// photos[0] renders as src="[object Object]" and blanks photo galleries.
export const normalizePhotos = (photos: unknown): string[] => {
  if (!Array.isArray(photos)) return [];
  const urls: string[] = [];
  for (const entry of photos) {
    if (typeof entry === 'string') {
      const trimmed = entry.trim();
      if (trimmed) urls.push(trimmed);
    } else if (entry !== null && typeof entry === 'object') {
      const url = (entry as Record<string, unknown>).url;
      if (typeof url === 'string' && url.trim()) urls.push(url.trim());
    }
  }
  return urls;
};

export const formatSchedule = (schedule: any): string => {
  if (!schedule) return 'Schedule not available';
  
  const startDate = parseCalendarDate(schedule.start_date) ?? new Date(NaN);
  const endDate = parseCalendarDate(schedule.end_date) ?? new Date(NaN);
  
  const startMonth = startDate.toLocaleString('default', { month: 'short' });
  const endMonth = endDate.toLocaleString('default', { month: 'short' });
  
  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  
  const hours = schedule.hours 
    ? `${schedule.hours.start.substring(0, 5)}-${schedule.hours.end.substring(0, 5)}` 
    : '';
  
  return `${startMonth} ${startDay} - ${endMonth} ${endDay} • ${hours}`;
};
